import { Plus } from 'lucide-react';

interface FloatingButtonProps {
  onClick: () => void;
}

export const FloatingButton = ({ onClick }: FloatingButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex fixed right-8 bottom-8 z-50 justify-center items-center w-14 h-14 text-white bg-blue-600 rounded-full shadow-lg transition-all hover:bg-blue-700 hover:scale-110 active:scale-95"
      title="비교 데이터 입력"
    >
      <Plus className="w-6 h-6" />
    </button>
  );
};
